import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ReportsRequests} from "../../../services/reports-requests.service";
import {BringozLoaderService} from "../../../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../../../commons/services/commons-alerts.service";
import {ResizeService} from "../../../../commons/services/resize-service.service";
import {DateRangeTimeFiltersService} from "../../../../commons/services/date-range-time-filters.service";

declare let google: any;

export class ReportsSiteCreatedDeliveriesCtrl implements IController {
  from: any;
  to: any;

  private readonly colorByStatus: any;
  private totalsDataTableCopy: any;
  private totalsDataTable: any;
  private allDeliveriesDataTable: any;
  private totals: any;
  private limit: any;
  private offset: any;
  private totalDeliveriesConfig: any;
  private filterConfig: any;
  private expend: any;
  private flex: any;
  private dataTableRowsCount: any;

  /* @ngInject */
  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private reportsRequests: ReportsRequests, private bringozLoaderService: BringozLoaderService, private $log,
              private commonsAlertsService: CommonsAlertsService, private chartColors, private resizeService: ResizeService, private splitService, private $state) {
    this.colorByStatus = this.chartColors.colorByStatus;
  }

  $onInit() {
    this.totals = {};

    this.totalDeliveriesConfig = {
      groupBy: undefined,
      viewType: undefined
    };

    this.filterConfig = {
      from: undefined,
      to: undefined,
      branchId: undefined,
      demandIds: [],
      supplyId: undefined,
      agentIds: [],
      tagNames: []
    };

    this.expend = {
      top: true,
      bottom: false
    };

    this.flex = {
      top: undefined,
      bottom: 'none'
    };


    this.totalDeliveriesConfig = {
      groupBy: 'Day',
      viewType: 'Chart'
    };
    this.filterConfig = {
      from: this.from ? this.from : this.dateRangeTimeFiltersService.lastMonth().dateStart,
      to: this.to ? this.to : this.dateRangeTimeFiltersService.lastMonth().dateEnd,
      branchId: undefined,
      demandIds: [],
      supplyId: undefined,
      agentIds: [],
      tagNames: [],
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.lastMonth(),
      customTemplates: this.dateRangeTimeFiltersService.getReportCustomTemplates()
    };

    this._generateReports()


  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  onRangeChanged(range) {
    this.filterConfig.range = range;
    this.$state.go('.', {from: range.dateStart, to: range.dateEnd}, {notify: false, reload: false});
    this._generateReports();
  }

  onFiltersChange(branchId, demandIds, supplyId, agentIds, tagNames) {
    this.filterConfig.branchId = branchId;
    this.filterConfig.demandIds = demandIds;
    this.filterConfig.supplyId = supplyId;
    this.filterConfig.agentIds = agentIds;
    this.filterConfig.tagNames = tagNames;
    this._generateReports();
  }

  onChangeGroup(group) {
    this.totalDeliveriesConfig.groupBy = group;
    this._generateReports();
  }

  onChangeViewType(viewType) {
    this.totalDeliveriesConfig.viewType = viewType;
    if (this.totalsDataTableCopy) {
      this.totalsDataTable = this._getDataTableByViewType(this.totalsDataTableCopy, viewType);
    }
  }

  onExport(event) {
    const payload: any = this._getQueryPayload();

    this.bringozLoaderService.on();
    this.reportsRequests.exportDeliveries(undefined, undefined, payload.createdFrom, payload.createdTo, payload.demandIds,
      payload.supplyIds, payload.agentIds, payload.tagNames)
      .then((file) => {
        this.commonsAlertsService.exportToMailSuccess();
      })
      .catch((error) => {
        this.commonsAlertsService.exportToMailError();
        this.$log.error('Failed to export file', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onToggleExpend(sectionExpended) {
    this.expend[sectionExpended] = !this.expend[sectionExpended];
    this.flex[sectionExpended] = this.expend[sectionExpended] ? undefined : 'none';
    this.resizeService.resize();
  }

  onNext() {
    this.offset += this.limit;
    this._setDeliveriesReport();
  }

  onBack() {
    this.offset -= this.limit;
    this._setDeliveriesReport();
  }

  private _generateReports() {
    this.limit = 20;
    this.offset = 0;
    this._setDeliveriesReport();
    this._setTotals()
  }

  private _setDeliveriesReport() {
    const payload = this._getQueryPayload();
    const tq = 'limit ' + this.limit + ' offset ' + this.offset;

    this.bringozLoaderService.on();
    this.allDeliveriesDataTable = undefined;
    this.dataTableRowsCount = 0;
    this.reportsRequests.getDeliveriesReport(tq, undefined, undefined, payload.createdFrom, payload.createdTo, payload.branchId,
      payload.demandIds, payload.supplyId, payload.agentIds, payload.groupBy, payload.tagNames)
      .then((data) => {
        this.dataTableRowsCount = _.get(data, 'rows.length', 0);
        if (data.rows && data.rows.length) {
          this.allDeliveriesDataTable = new google.visualization.DataTable(data);
        }
      })
      .catch((error) => {
        this.$log.error('Failed to query deliveries report @reportsDeliveries@_query', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _setTotals() {
    const payload: any = this._getQueryPayload();

    this.totalsDataTable = undefined;
    this.totalsDataTableCopy = undefined;

    // For Chart View
    this.totals = undefined;

    this.bringozLoaderService.on();
    this.reportsRequests.getDeliveriesTotals(payload.tq, undefined, undefined, payload.createdFrom, payload.createdTo, payload.branchId,
      payload.demandIds, payload.supplyId, payload.agentIds, payload.groupBy, payload.tagNames)
      .then((totalsData) => {
        if (totalsData.rows && totalsData.rows.length) {
          this.totalsDataTableCopy = new google.visualization.DataTable(totalsData);
          this.totalsDataTable = this._getDataTableByViewType(this.totalsDataTableCopy, this.totalDeliveriesConfig.viewType);
          this.totals = this._getTotals(totalsData);
        }
      })
      .catch((error) => {
        this.$log.error('Failed to get reports deliveries total @reportsSiteDeliveries@_setTotals', error);
        this.commonsAlertsService.somethingWentWrongError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _getQueryPayload() {
    return {
      // tq: 'order by DeliveryId, DriverName desc limit ' + ctrl.limit + ' offset ' + ctrl.offset,
      // tq: 'limit ' + ctrl.limit + ' offset ' + ctrl.offset,
      createdFrom: this.filterConfig.range.dateStart,
      createdTo: this.filterConfig.range.dateEnd,
      branchId: this.filterConfig.branchId,
      demandIds: this.filterConfig.demandIds?.length ? this.filterConfig.demandIds : undefined,
      supplyId: this.filterConfig.supplyId,
      agentIds: this.filterConfig.agentIds?.length ? this.filterConfig.agentIds : undefined,
      groupBy: this.totalDeliveriesConfig.groupBy,
      tagNames: this.filterConfig.tagNames?.length ? this.filterConfig.tagNames : undefined
    }
  }

  private _getDataTableByViewType(dataTable, viewType) {
    var totalsDataTable = angular.copy(dataTable);
    totalsDataTable.removeColumn(5);
    // totalsDataTable.setColumns([0,2,3,4,5]);  Another way to get the needed columns.

    if (viewType === 'Chart') {
      // totalsDataTable.removeColumn(0);
    }

    return totalsDataTable;
  }

  private _getTotals(totalsDataTable) {
    var totals = {};
    _.forEach(totalsDataTable.cols, (col, index) => {
      if (col.type === "number") {
        totals[col.id] = _.sumBy(totalsDataTable.rows, (row: any) => {
          return row.c[index].v;
        });
      }
    });
    return totals;
  }


}

angular
  .module('bringoz.admin.reports')
  .component('reportsSiteCreatedDeliveries', {
    bindings: {
      from: '<',
      to: '<'
    },
    template: require('./reports-site-created-deliveries.html').default,
    controller: ReportsSiteCreatedDeliveriesCtrl
  });
